// NOTE: There is a known issue where each directory/file needs to be clicked twice to toggle it. This only happens in dev, probably because of Strict Mode. I *should* dig into it and figure out the issue, but whatever, it works in prod.

import React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Space from '@/components/Space';

import Sidebar from './Sidebar';
import FileContent from './FileContent';
import { getFile, isFile } from './FileViewer.helpers';

import type { FileGroup } from './FileViewer.types';

interface Props {
  minHeight?: number;
  maxHeight?: number;
  initialFiles: FileGroup;
}

function FileViewer({
  minHeight = 420,
  maxHeight,
  initialFiles,
}: Props) {
  const [files, setFiles] = React.useState<FileGroup>(initialFiles);

  const activeFile = getFile(files, (item) => {
    return isFile(item) ? !!item.isSelected : false;
  });

  return (
    <Wrapper
      style={{
        '--min-content-height': minHeight + 'px',
        '--max-content-height':
          typeof maxHeight === 'undefined'
            ? undefined
            : maxHeight + 'px',
      }}
    >
      <Sidebar files={files} setFiles={setFiles} />
      <FlexedFileContent file={activeFile} />
    </Wrapper>
  );
}

const Wrapper = styled(Space)`
  display: flex;
  gap: 8px;
  padding: 16px;
  margin: 0 -32px;
  border: 1px solid var(--color-content-outline);
  margin-bottom: 64px;

  @media ${BREAKPOINTS.mdAndSmaller} {
    flex-direction: column;
    gap: 16px;
  }
`;

const FlexedFileContent = styled(FileContent)`
  flex: 1;
`;

export default FileViewer;
